import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

import iconDownload from '../images/icons/buttons/Download.svg'
import '../styles/components/rectangleLink.scss';

const RectangleLink = (props) => {
  const {
    download = false,
    classNameLink = '',
    iconDownloadBool = true,
    label = '',
    link = '',
    target = '_self',
    title = '',
    to = '',
  } = props;

  const linkContent = (
    <>
      {iconDownloadBool && <img className="Rectangle_link-Icon_download" src={iconDownload} alt=""/>}

      <span dangerouslySetInnerHTML={{ __html: title }} />
    </>
  );

  return (
    <div className="Rectangle_link">
      <div className="Rectangle_link-Cell">
        {label && <label className="Rectangle_link-Label">{label}</label>}

        {to ? (
          <Link
            className={`Rectangle_link-Content ${classNameLink}`}
            to={to}
          >
            {linkContent}
          </Link>
        ) : (          
          <a
            className={`Rectangle_link-Content ${classNameLink}`}
            download={download}
            href={link}
            target={target}
          >
            {linkContent}
          </a>
        )}
      </div>
    </div>
  );
};

export const RectangleLinkPropTypes = {
  download: PropTypes.bool,
  label: PropTypes.string,
  link: PropTypes.string,
  target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
  to: PropTypes.string,
  title: PropTypes.string,
};

RectangleLink.propTypes = RectangleLinkPropTypes;

export default RectangleLink;
